import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ffb6c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-title",
  size: "medium"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fiserv-title" }, " Fiserv ", -1))
const _hoisted_3 = {
  class: "profit-item",
  style: {"margin-bottom":"0.5em"}
}
const _hoisted_4 = { class: "profit-area" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profit-title" }, "Zysk", -1))
const _hoisted_6 = { class: "profit-resultat" }
const _hoisted_7 = { class: "profit-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "profit-currency" }, "zł", -1))
const _hoisted_9 = { class: "profit-info" }
const _hoisted_10 = { class: "prof-income" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Koszyk:")
const _hoisted_12 = {
  style: {"font-size":"1.2em"},
  slot: "start"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"1.2em"},
  slot: "end"
}, "1,5%", -1))
const _hoisted_14 = {
  style: {"font-size":"1.4em"},
  class: "commision-info"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Terminal:")
const _hoisted_16 = {
  style: {"font-size":"1.2em"},
  slot: "start"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"1.2em"},
  slot: "end"
}, "60zł", -1))
const _hoisted_18 = {
  style: {"font-size":"1.4em"},
  class: "commision-info"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Obrót miesięcznie")
const _hoisted_20 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Błędne Hasło")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Hasło")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Odblokuj")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_range = _resolveComponent("ion-range")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { color: "primary" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        style: _normalizeStyle(_ctx.bgColor)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--ion-toolbar-background":"#15100D"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        style: {"margin-right":"10px"},
                        color: (_ctx.darkMode ? 'dark' : 'light'),
                        slot: "icon-only",
                        onClick: _ctx.changeColorTheme,
                        icon: (_ctx.darkMode ? _ctx.moon : _ctx.sunny)
                      }, null, 8, ["color", "onClick", "icon"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.isAppLocked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_ion_img, {
                          class: "logo-image-top",
                          src: "./assets/icon/logo-full-wide.jpeg"
                        }),
                        _hoisted_2
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.isAppLocked)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.commissions && _ctx.commissions.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.result), 1),
                            _hoisted_8
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, "Obrót: " + _toDisplayString(_ctx.income) + "zł | K: " + _toDisplayString(_ctx.commisionCalculated / 100) + "% | T: " + _toDisplayString(_ctx.calculatedExtra) + "zł", 1)
                          ])
                        ])
                      ]),
                      _createVNode(_component_ion_item, { style: {"margin-top":"0.5em"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { style: {"font-size":"1.3em"} }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            modelValue: _ctx.commisionSelect,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.commisionSelect) = $event)),
                            "ok-text": "Wybierz",
                            "cancel-text": "Anuluj"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commissions, (cmm, k) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  value: cmm.value,
                                  key: k
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cmm.price) + "zł", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.commisionSelect)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            style: {"margin-bottom":"0em"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_range, {
                                min: (_ctx.commisionSelect * 100),
                                max: 150,
                                step: "1",
                                modelValue: _ctx.commisionSliderValue,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.commisionSliderValue) = $event)),
                                "pin-formatter": _ctx.commisionPinFormat,
                                snaps: "",
                                pin: "",
                                ticks: "",
                                class: "no-padding-range",
                                color: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.commisionSelect) + "%", 1),
                                  _hoisted_13
                                ]),
                                _: 1
                              }, 8, ["min", "modelValue", "pin-formatter"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.commisionSelect)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 1,
                            class: "actions-buttons",
                            style: {"margin-bottom":"0.5em","--border-width":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                size: "default",
                                style: {"--background":"#F72405","--color":"#fff"},
                                onClick: _cache[2] || (_cache[2] = () => { _ctx.commisionSliderValue > (_ctx.commisionSelect * 100) ? _ctx.commisionSliderValue -= 1 : null })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.remove }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.commisionPinFormat(_ctx.commisionSliderValue)), 1),
                              _createVNode(_component_ion_button, {
                                color: "tertiary",
                                size: "default",
                                onClick: _cache[3] || (_cache[3] = () => { _ctx.commisionSliderValue < 150 ? _ctx.commisionSliderValue += 1 : null })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, { style: {"margin-top":"0.5em"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { style: {"font-size":"1.3em"} }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            modelValue: _ctx.terminalSelect,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terminalSelect) = $event)),
                            "ok-text": "Wybierz",
                            "cancel-text": "Anuluj"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terminals, (trm, k) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  value: trm.value,
                                  key: k
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trm.value) + "zł", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedeErminalByTS && _ctx.selectedeErminalByTS.allowRange)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 2,
                            style: {"margin-bottom":"0em"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_range, {
                                min: _ctx.terminalSelect,
                                max: 60,
                                step: "1",
                                modelValue: _ctx.terminalSliderValue,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.terminalSliderValue) = $event)),
                                "pin-formatter": _ctx.terminalPinFormat,
                                pin: "",
                                class: "no-padding-range",
                                color: "tertiary"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.terminalSelect) + "zł", 1),
                                  _hoisted_17
                                ]),
                                _: 1
                              }, 8, ["min", "modelValue", "pin-formatter"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.selectedeErminalByTS && _ctx.selectedeErminalByTS.allowRange)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 3,
                            class: "actions-buttons",
                            style: {"margin-bottom":"0.5em","--border-width":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                style: {"--background":"#F72405","--color":"#fff"},
                                size: "default",
                                onClick: _cache[6] || (_cache[6] = () => { _ctx.terminalSliderValue > _ctx.terminalSelect ? _ctx.terminalSliderValue -= 1 : null })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.remove }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.terminalPinFormat(_ctx.terminalSliderValue)) + " netto", 1),
                              _createVNode(_component_ion_button, {
                                size: "default",
                                onClick: _cache[7] || (_cache[7] = () => { _ctx.terminalSliderValue < 60 ? _ctx.terminalSliderValue += 1 : null }),
                                color: "tertiary"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, { style: {"margin":"0.5em 0"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            style: {"font-size":"1.4em","margin-bottom":"15px"},
                            position: "stacked"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }),
                          (!_ctx.terminalSelect || !_ctx.commisionSelect)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Koszyk oraz terminal muszą zostać wybrane"))
                            : _createCommentVNode("", true),
                          _createElementVNode("form", {
                            name: "form",
                            onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            (_ctx.terminalSelect && _ctx.commisionSelect)
                              ? (_openBlock(), _createBlock(_component_ion_input, {
                                  key: 0,
                                  inputmode: "tel",
                                  onKeyup: _withKeys(_ctx.onKeyEnter, ["enter"]),
                                  enterkeyhint: "done",
                                  style: {"font-size":"2em","font-weight":"bold"},
                                  min: 0,
                                  name: "income",
                                  modelValue: _ctx.income,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.income) = $event)),
                                  type: "phone"
                                }, null, 8, ["onKeyup", "modelValue"]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_spinner, { color: "tertiary" })
                      ]),
                      _: 1
                    }))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_ion_img, {
                  class: "logo-image-top",
                  src: "./assets/icon/logo-full-wide.jpeg"
                }),
                (_ctx.appPassError)
                  ? (_openBlock(), _createBlock(_component_ion_title, {
                      key: 0,
                      class: "pass-error"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  class: "pass-form",
                  name: "form",
                  onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unlockApp && _ctx.unlockApp(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        required: "",
                        enterkeyhint: "done",
                        style: {"font-size":"2em","font-weight":"bold"},
                        min: 0,
                        placehodler: "hasło",
                        name: "appPassword",
                        color: "danger",
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.password) = $event)),
                        type: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    style: {"margin-top":"15px"},
                    size: "default",
                    color: "danger",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ], 32)
              ], 64))
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}